module.exports = "https://tutorchat.chegg.com/static/media/ic-profile.4349e593.svg";